import script from "./resetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPassword.vue?vue&type=script&setup=true&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=75999201&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75999201"]])

export default __exports__